module.exports = __webpack_public_path__ + "static/media/JohnsonsBaby-Bold.36e588b3.eot";